import React from 'react';
import type { RouteComponentProps } from '@gatsbyjs/reach-router';
import { useRecoilState, useRecoilValue } from 'recoil';
import { biedwijzerContentState, biedwijzerInitialContentState } from '../..';
import AppDetailsContainer from '../../../components/AppDetailsContainer';

import { StepName } from '../MainPreview/types';
import MainPreview from '../MainPreview';
import { mergeDeepRight } from 'ramda';
import type { AppBbWaardecheckText, UnionImage } from '~/graphql/types';
import ImageOrAssetInput from '~/components/organism/ImageOrAssetInput';
import useUnionImageUrl from '~/hooks/useUnionImageUrl';

const text = {
  header: 'Adres zoeken',
};

type Props = RouteComponentProps;

const AddressSearch: React.FCC<Props> = () => {
  const initialValues = useRecoilValue(biedwijzerInitialContentState);
  const [values, setValues] = useRecoilState(biedwijzerContentState);

  const onUpdate = (
    fieldName: string,
    value: Partial<AppBbWaardecheckText> | UnionImage,
  ) => {
    setValues(prev => {
      if (!prev) return prev;

      return {
        ...prev,
        content: prev.content
          ? {
              ...prev.content,
              addressSearch: {
                ...prev.content.addressSearch,
                [fieldName]: mergeDeepRight(
                  prev.content.addressSearch[fieldName],
                  value,
                ),
              },
            }
          : prev.content,
      };
    });
  };

  const addressImageUrl = useUnionImageUrl({
    image: values?.content?.addressSearch.image,
    defaultImage: null,
  });

  if (!values) return null;

  return (
    <AppDetailsContainer header={text.header} icon="map-pin">
      <MainPreview
        values={values?.content}
        data={{
          appConfigData: {
            address: {
              image: {
                src: addressImageUrl || '',
              },
            },
          },
          initialState: {
            step: StepName.AddressSearch,
            previewMode: true,
          },
        }}
        step={StepName.AddressSearch}
      />

      <ImageOrAssetInput
        title="Sfeerfoto"
        description="Stel een sfeerfoto in die wordt getoond in de aanvraagwizard."
        initialImage={initialValues?.content?.addressSearch.image}
        currentImage={values?.content?.addressSearch.image}
        imageFileName="addressImage"
        onParentUpdate={args => {
          if (!args) return;
          onUpdate('image', args);
        }}
      />
    </AppDetailsContainer>
  );
};

export default AddressSearch;
